module.exports = __webpack_public_path__ + "static/media/credit-card.52784a86.svg";